export default {"src":"/_next/static/media/guard.a1ee8b06.svg","height":25,"width":83,"blurWidth":0,"blurHeight":0};